<!--阅卷信息-->
<template>
	<div class="operate-bar">
		<span class="student_id" :title="studentId">序号：{{ studentId }}</span>
		<!--    v-show="isMarkBoardState" 暂时把放大和缩小图片转态取消-->
		<i class="iconfont iconfangda" title="放大图片" @click="scalePaper"></i>
		<!--    v-show="isMarkBoardState"-->
		<i class="iconfont iconfangda1" title="缩小图片" @click="lessenPaper"></i>
		<i class="iconfont iconfangda2" title="扩大试卷切图" v-if="!miniScaleState" @click="scalePage"></i>
		<i class="iconfont iconsuoxiao" title="恢复切图" v-if="miniScaleState" @click="lessenPage"></i>
		<!--<i class="iconfont iconziyuan11" title="旋转图片" v-if="type === '2'" @click="rotatePaper"></i>-->
		<i class="iconfont iconyi" title="设置疑难卷" @click="setDifficultPaper" v-if="type !== '2'"></i>
		<i class="iconfont" title="设置典型卷" @click="setTypical">典</i>
		<i class="iconfont icon-zhongxinjiazai" title="刷新试卷切块" @click="flushPaper"></i>
		<el-switch v-model="isRemember" active-text="记住拖动" @change="changeRemberPos"></el-switch>
		<guide
			class="operate-guide"
			v-show="guideStep === 3"
			title="操作区"
			distribute="操作区包括：放大图片，缩小图片，放大试卷，缩小试卷，设置疑难卷，设置典型卷，重新加载试卷"
		/>
	</div>
</template>

<script>
import guideMixin from '../utils/guide-mixin'
export default {
	name: 'operate-bar',
	mixins: [guideMixin],
	props: {
		studentId: { type: [String, Number] },
		miniScaleState: { type: Boolean, default: false },
		type: null
	},
	data() {
		return {
			isMarkBoardState: true,
			//是否记忆
			isRemember: true
		}
	},
	components: {
		guide: () => import('./guide')
	},
	mounted() {
		this.watchCurrentEmit()
	},
	methods: {
		watchCurrentEmit() {
			this.eventBus.$on('markBoardState', cb => (this.isMarkBoardState = cb))
		},
		//放大图片
		scalePaper() {
			this.$emit('scalePaper')
		},
		//缩小图片
		lessenPaper() {
			this.$emit('lessenPaper')
		},
		//扩大切图
		scalePage() {
			this.$emit('scalePage')
		},
		//缩小切图
		lessenPage() {
			this.$emit('lessenPage')
		},
		setDifficultPaper() {
			this.$emit('setDifficultPaper')
		},
		setTypical() {
			this.$emit('setTypical')
		},
		flushPaper() {
			this.$emit('flushPaper')
		},
		//  记住筛选
		changeRemberPos(val) {
			this.eventBus.$emit('changePosState', val)
		}
	}
}
</script>

<style scoped lang="less">
.operate-bar {
	width: 100%;
	padding: 0 30px 0 8px;
	height: 50px;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	background: white;
	position: relative;
	z-index: 1;
	.iconfullscreen- {
		position: absolute;
		right: 70px;
	}
	@media screen and (max-width: 1920px) {
		height: 35px;
	}
	.student_id {
		max-width: 500px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		padding-right: 20px;
	}
	.iconfont {
		font-size: 25px;
		font-weight: 500;
		margin-right: 20px;
		cursor: pointer;
		color: #666666;
		@media screen and (max-width: 1920px) {
			font-size: 21px;
		}
	}
}
</style>
